var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImpossibleTravel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 23,
    viewBox: "0 0 34 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#6B696A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M3.999 19.012c0 1.1-.895 1.992-2 1.992C.895 21.004 0 20.113 0 19.012c0-1.1.895-1.992 2-1.992 1.104 0 1.999.89 1.999 1.992zm27.341 0c0 1.1-.895 1.992-2 1.992-1.103 0-1.998-.891-1.998-1.992 0-1.1.895-1.992 1.999-1.992s2 .89 2 1.992h-.001zm-4.598-2.325c.43.179.867.377 1.298.584l-1.298-.584zm-19.775-.875c.797-.255 1.617-.478 2.436-.66l-2.436.66zm14.964-.662c.818.182 1.638.404 2.437.66l-2.437-.66zm-10.041-.441c.83-.11 1.677-.182 2.515-.22l-2.515.22zm5.04-.22c.84.038 1.687.11 2.515.22l-2.515-.22zM3.301 17.272c.425-.205.861-.401 1.297-.585l-1.297.585z",
    transform: "translate(-68 -494) translate(69.492 495.241)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6B696A",
    d: "M16.87 14.562c0 .659-.537 1.195-1.2 1.195-.662 0-1.2-.534-1.2-1.195 0-.66.538-1.195 1.2-1.195.663 0 1.2.535 1.2 1.194",
    transform: "translate(-68 -494) translate(69.492 495.241)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6B696A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M16.87 14.562c0 .659-.537 1.195-1.2 1.195-.662 0-1.2-.534-1.2-1.195 0-.66.538-1.195 1.2-1.195.663 0 1.2.535 1.2 1.194z",
    transform: "translate(-68 -494) translate(69.492 495.241)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.519 6.634c-.646-.002-1.169-.526-1.171-1.171-.001-.646.521-1.17 1.167-1.167.646 0 1.17.525 1.171 1.17.001.647-.521 1.169-1.167 1.168zm-7.796-2.55c-2.822-2.376-4.699.497-7.009 1.382 2.313.893 4.201 3.772 7.014 1.407l-.005-2.788z",
    transform: "translate(-68 -494) translate(69.492 495.241)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.286 6.623c1.497.862 4.643 1.565 7.166 1.57 4.502.008 7.246-2.714 7.246-2.714s-2.753-2.732-7.255-2.74c-2.523-.005-5.667.689-7.16 1.546l.002 2.337.001.001z",
    transform: "translate(-68 -494) translate(69.492 495.241)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.01 5.459l-4.673-.009m5.423 2.338l-3.29 3.12-2.516-1.149 1.557-.895.775-2.242m3.466-3.491L12.452 0 9.94 1.141l1.56.899.783 2.245",
    transform: "translate(-68 -494) translate(69.492 495.241)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpossibleTravel);
export default __webpack_public_path__ + "static/media/impossible_travel.da8b92cf2eba3a002ffc6ef2c97de945.svg";
export { ForwardRef as ReactComponent };